import { RepositoryFactory } from "../../Apicall/masters/RepositoryFactory";
const billing = RepositoryFactory.get("billing");
import store from "../store";

const admin = RepositoryFactory.get("admin");
const builder = RepositoryFactory.get("builder");
const scopeRepository = RepositoryFactory.get("plan");
export default {
  async getPlans({ commit }, payload) {
    const response = await billing.getAllPlans(payload);
    const plans = response.data.data.sort((a, b) => a.number - b.number);
    if (store.state.admin.login.countryCode.iso2 == "SG") {
      const strIndex = response.data.data.findIndex((x) => x.name == "Starter");
      const proIndex = response.data.data.findIndex(
        (x) => x.name == "Prototype"
      );
      const essIndex = response.data.data.findIndex(
        (x) => x.name == "Essential"
      );
      const bussIndex = response.data.data.findIndex(
        (x) => x.name == "Business"
      );
      const enterIndex = response.data.data.findIndex(
        (x) => x.name == "Enterprise"
      );
      plans[strIndex].plans[1].price = "S$19";
      plans[essIndex].plans[1].price = "S$199";
      plans[proIndex].plans[1].price = "S$89";
      plans[bussIndex].plans[1].price = "S$899";
      plans[enterIndex].plans[0].price = "S$12000";
    }
    commit("SET_PLANS", plans);
  },
  async getSuitesData({ commit }, payload) {
    const response = await builder.getSuitesData(payload);
    commit("SET_SUITE_DATA", response.data.data);
  },
  async getResellerOffer({ commit }, payload) {
    const response = await scopeRepository.getResellerOffer(payload);
    return response;
  },
  async getResellerLeadOffer({ commit }, payload) {
    const response = await scopeRepository.getResellerLeadOffer(payload);
    return response;
  },
  async getStories({ commit }, payload) {
    const response = await builder.getStories(payload);
    return response;
  },
  async defaultProjectVersion({ commit }, payload) {
    const response = await builder.defaultProjectVersion(payload);
    return response;
  },
  async addRolesToProject({ commit }, payload) {
    const response = await builder.addRolesToProject(payload);
    return response;
  },
  async addPagesToProject({ commit }, payload) {
    const response = await builder.addPagesToProject(payload);
    return response;
  },
  async getDefaultPages({ commit }, payload) {
    const response = await builder.getDefaultPages(payload);
    return response;
  },
  async createProject({ commit }, payload) {
    const response = await builder.createProject(payload);
    return response;
  },
  async getProject({ commit }, payload) {
    const response = await scopeRepository.getProject(payload);
    return response;
  },
  getProjectData({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await admin.getProject(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
